/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDUturnUpLeftIcon16Light } from './ArrowDUturnUpLeftIcon16Light';
import { ArrowDUturnUpLeftIcon16Regular } from './ArrowDUturnUpLeftIcon16Regular';
import { ArrowDUturnUpLeftIcon16Solid } from './ArrowDUturnUpLeftIcon16Solid';
import { ArrowDUturnUpLeftIcon20Light } from './ArrowDUturnUpLeftIcon20Light';
import { ArrowDUturnUpLeftIcon20Regular } from './ArrowDUturnUpLeftIcon20Regular';
import { ArrowDUturnUpLeftIcon20Solid } from './ArrowDUturnUpLeftIcon20Solid';
import { ArrowDUturnUpLeftIcon24Regular } from './ArrowDUturnUpLeftIcon24Regular';
import { ArrowDUturnUpLeftIcon24Solid } from './ArrowDUturnUpLeftIcon24Solid';
import { ArrowDUturnUpLeftIcon32Regular } from './ArrowDUturnUpLeftIcon32Regular';
import { ArrowDUturnUpLeftIcon64Regular } from './ArrowDUturnUpLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowDUturnUpLeftIcon16Light,
        regular: ArrowDUturnUpLeftIcon16Regular,
        solid: ArrowDUturnUpLeftIcon16Solid,
    },
    20: {
        light: ArrowDUturnUpLeftIcon20Light,
        regular: ArrowDUturnUpLeftIcon20Regular,
        solid: ArrowDUturnUpLeftIcon20Solid,
    },
    24: {
        regular: ArrowDUturnUpLeftIcon24Regular,
        solid: ArrowDUturnUpLeftIcon24Solid,
    },
    32: {
        regular: ArrowDUturnUpLeftIcon32Regular,
    },
    64: {
        regular: ArrowDUturnUpLeftIcon64Regular,
    },
};
export var ArrowDUturnUpLeftIcon = forwardRef('ArrowDUturnUpLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
